.label {
  position: relative;
  cursor: pointer;
}

.inputContainer {
  height: 24px;
}

.radio {
  width: 24px;
  height: 24px;
  appearance: none;
  cursor: pointer;
  border: 1px solid black;
  border-radius: 100px;

  &:checked {
    background-color: black;

    &::after {
      display: block;
      width: 10px;
      height: 10px;
      margin: 6px;
      content: '';
      background-color: white;
      border-radius: 100px;
    }
  }
}
